    <app-upload (complete)="uplaodCompleted($event)"></app-upload>
